
/* injects from baggage-loader */

'use strict';

export default class InviteUserModalController {

	constructor($log, $timeout, Parse, Validations) {
		'ngInject';

		this.$log = $log;
		this.$timeout = $timeout;
		this.Parse = Parse;
		this.Validations = Validations;

		this.user = {
			email: '',
			role: 'manager'
		}

		this.inviting_user = false;
		this.error_msg = '';

	}

	$onInit() {

		// Grab roles from resolved context
		this.roles = this.resolve.context.roles;
		this.group = this.resolve.context.group || {};

	}

	getInputSubtext() {
		return this.group.id
			? 'We will send an email to this address inviting the person to access this group.'
			: 'We will send an email to this address inviting the person to join your company.'
	}

	ok() {

		this.error_msg = '';

		if (!this.Validations.isEmail(this.user.email)) {
			this.error_msg = 'A valid email address is required.';
			return false;
		}

		this.inviting_user = true;

		this.Parse.Cloud.run('inviteUser', {
			user: this.user,
			groupId: this.group.id
		}).then(async result => {

			this.inviting_user = false;
			this.close({
				$value: {
					user: this.user
				}
			});

		})
			.catch(err => {
				this.$log.error(err)
				this.error_msg = err.toString().replace('ParseError: 141', '');
				this.inviting_user = false;
				this.$timeout();
			})

	}

	cancel() {
		this.dismiss({ $value: 'cancel' });
	}

}



// WEBPACK FOOTER //
// ./src/app/components/inviteUserModal/inviteusermodal.controller.js